import api from '@/api'
import { MenuItem } from '@/interfaces/MenuItem'
import { OptionApiModel } from '@/interfaces/OptionApiModel'
import { OptionTypeApiModel } from '@/interfaces/OptionTypeApiModel'
import lodash from 'lodash'
import { OptionCategoryApiModel } from '@/interfaces/OptionCategoryApiModel'

import { defineStore } from 'pinia'

export const useOptionStore = defineStore('option', {
  state: () => ({
    menuItems: [] as Array<MenuItem>,
    allOptions: [] as Array<OptionApiModel>,
    allCategories: [] as Array<OptionCategoryApiModel>,
    optionTypes: [] as Array<OptionTypeApiModel>,
    fetchedList: false,
    fetchedProductCode: '',
    unfilteredMenuItems: [] as Array<MenuItem>
  }),
  getters: {
    canHaveBase: (state) => state.menuItems.some(type => type.categories.some(cat => cat.code === 'base'))
  },
  actions: {
    async loadOptions(productCode: string): Promise<boolean> {
      if (!this.fetchedList) {
        try {
          const response = await api.get('/options/')
          this.unfilteredMenuItems = response.data
          this.optionTypes = lodash.uniqBy(this.unfilteredMenuItems.flatMap(mi => mi.categories).flatMap(c => c.options).map(o => o.optionType), o => o.id)
          this.fetchedList = true
        } catch (error) {
          return false
        }
      }

      if (this.fetchedProductCode === productCode) {
        return true
      } else {
        this.fetchedProductCode = productCode
        this.menuItems = this.unfilteredMenuItems.map(sourceMenuItem => {
          const clonedMenuItem = Object.assign({}, sourceMenuItem)

          clonedMenuItem.categories = sourceMenuItem.categories.map(sourceCategory => {
            const clonedCategory = Object.assign({}, sourceCategory)
            clonedCategory.options = sourceCategory
              .options
              .filter(o => o.products.some(p => p.productCode === productCode))
              .map(sourceOption => {
                sourceOption.isFallbackDefault = sourceOption.products.some(p => p.productCode === productCode && p.isFallbackDefault)
                return sourceOption
              })

            clonedCategory.options = lodash.sortBy(clonedCategory.options, x => x.seq)

            return clonedCategory
          }).filter(c => c.options.length > 0)

          clonedMenuItem.categories = lodash.sortBy(clonedMenuItem.categories, x => x.seq)
          return clonedMenuItem
        }).filter(mi => mi.categories.length > 0)

        this.allCategories = this.menuItems.flatMap(mi => mi.categories)
        this.allOptions = this.allCategories.flatMap(c => c.options)

        this.allCategories.forEach(category => {
          this.optionTypes.forEach(optionType => {
            const options = category.options.filter(o => o.optionType.type === optionType.type)
            const fallbackOption = options.find(o => o.isFallbackDefault)

            options.forEach(o => {
              o.removable = o.optionType.optional || (!!fallbackOption && o.code !== fallbackOption.code)
            })
          })
        })

        return true
      }
    }
  }
})
